<ng-select
        class="custom"
        #select
        [items]="entries$ | async"
        bindLabel="name"
        [trackByFn]="trackByFn"
        [minTermLength]="3"
        [loading]="loading"
        [formControl]="formControl"
        placeholder="{{'label.cust_order' | translate}}"
        typeToSearchText="Digita almeno 3 caratteri"
        [typeahead]="input$"
        [readonly]="_readonly"
        (change)="onInput($event)"
        (blur)="onTouched()"
        >

  <ng-template ng-label-tmp let-item="item">
    <div>{{ item.code }}
    <small> ({{ item.project?.name ? item.project.name : item.project }}<b> - {{ item.account ? item.account.businessName : item.customer }})</b></small>
    </div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div>{{ item.code }}</div>
    <small>{{ item.project }}<b> - {{ item.customer }}</b></small>
  </ng-template>
</ng-select>